import { useRef } from "react";

type SwipeDirection = "left" | "right" | "up" | "down";

export function useSwipe(
    onSwipe: (direction: SwipeDirection) => void,
    threshold = 50
) {
    const startX = useRef(0);
    const startY = useRef(0);

    const onPointerDown = (e: React.PointerEvent) => {
        startX.current = e.clientX;
        startY.current = e.clientY;
    };

    const onPointerUp = (e: React.PointerEvent) => {
        const dx = e.clientX - startX.current;
        const dy = e.clientY - startY.current;

        const absX = Math.abs(dx);
        const absY = Math.abs(dy);

        if (Math.max(absX, absY) < threshold) return;

        if (absX > absY) {
            onSwipe(dx > 0 ? "right" : "left");
        } else {
            onSwipe(dy > 0 ? "down" : "up");
        }
    };

    return { onPointerDown, onPointerUp };
}